import { combineReducers } from 'redux';
import navigationStructure from './navigation-structure';

const navigationReducer = combineReducers({
  navigationStructure,
});

export default navigationReducer;
